'use client'

import { useContext, useEffect, useState } from 'react'
import { RootContext } from '@/modules/contextService'
import { RootProps } from '../layout'
import ThemeClient from '../v1/ThemeClient'
import PublisherHeader from '@/components/display/PublisherHeader'
import NextLink from 'next/link'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import styles from '../self/styles.module.scss'
import policyStyle from './policies.module.scss'
import MainFooter from '@/components/MainFooter'
import cookieService from '@/modules/cookieService'

function SelfLayout ({ children }: RootProps) {
  const { rootData } = useContext(RootContext)
  const { user } = rootData
  const [selectedTheme, setSelectedTheme] = useState('')

  useEffect(() => {
    const storedTheme = cookieService.getCookie('theme')
    setSelectedTheme(storedTheme || 'dark')
  }, [])

  return (
    <section>
      <style>{'body { background-color: var(--background-color); color: var(--primary-font-rgb); }'}</style>
      <ThemeClient theme={selectedTheme}>
        <div className={styles.main}>
          <PublisherHeader user={user} size={'small'} />
          <div className={policyStyle.header}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                aria-label="policy tabs"
                centered
                scrollButtons
                allowScrollButtonsMobile
                variant="scrollable"
              >
                <NextLink href={'/policies/terms-of-service'}>
                  <Tab label="Terms of Service" style={{ textTransform: 'none', width: 150 }} />
                </NextLink>
                <NextLink href={'/policies/community-guidelines'}>
                  <Tab label="Community Guidelines" style={{ textTransform: 'none', width: 190 }} />
                </NextLink>
                <NextLink href={'/policies/statement-of-faith'}>
                  <Tab label="Statement of Faith" style={{ textTransform: 'none', width: 160 }} />
                </NextLink>
                <NextLink href={'/policies/privacy-policy'}>
                  <Tab label="Privacy Policy" style={{ textTransform: 'none', width: 130 }} />
                </NextLink>
              </Tabs>
            </Box>
          </div>
          <div className={styles.content}>
            {children}
          </div>
          <MainFooter />
        </div>
      </ThemeClient>
    </section>
  )
}

export default SelfLayout
